import { useBilling } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  onClose: () => void
  isOpen: boolean
  id?: string
}

export const RemoveItem = ({ isOpen, onClose, id }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { deleteItem } = useBilling({})
  const handleClose = () => {
    onClose()
    setIsLoading(false)
  }
  const deleteHandler = async () => {
    setIsLoading(true)
    try {
      await deleteItem({ id: id || '' })
      showToast('Item deleted successfully')
      handleClose()
    } catch (error) {
      getError(error)
    }
    setIsLoading(false)
  }
  return (
    <>
      {isOpen && (
        <DeleteModal
          description="Confirm that you want to delete this item"
          handleSubmit={deleteHandler}
          isLoading={isLoading}
          onClose={handleClose}
          title="Delete Invoice Item"
        />
      )}
    </>
  )
}
